import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {Lister} from '../../../common/wrapper.models';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {CalculationGoldListElement, CalculationGoldListQueryForm} from './calculation-gold.models';
import {queryKey} from './calculation-gold-querykeys';

export function useCalculationGoldListQuery(
  form: CalculationGoldListQueryForm,
): UseQueryResult<Lister<CalculationGoldListElement>> {
  return useQuery({
    queryKey: queryKey.listFilter(form),
    queryFn: () =>
      AxiosHttpClient.get<Lister<CalculationGoldListElement>>(
        `${environment.apiv4uri}calculation/gold/list`,
        form),
    enabled: true,
  });
}
